import { render, staticRenderFns } from "./KikiGallery.vue?vue&type=template&id=0e8deedd&"
import script from "./KikiGallery.vue?vue&type=script&lang=js&"
export * from "./KikiGallery.vue?vue&type=script&lang=js&"
import style0 from "./KikiGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports